import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router';
import * as ReportActions from '../../../actions/report_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import Header from '../../../components/header';
let screenIdentifier = 'PatientsSummery';
import { validate } from '../../../validations';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import C3Chart from 'react-c3js';
import 'c3/c3.css';
import '../../../css/issue.css';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { Loader } from './../../loader';
import moment from 'moment';

export var PatientsSummery = React.createClass({
  getInitialState() {
    return {

      modal: false, modal_msg: "", CurrentTab: 0, MySelfCare: null, MyThoughts: null, MyActivity: null, MyExperience: null,
      startDate: null,
      startDateDisplay: null,
      endDate: null,
      endDateDisplay: null,
      isSubmitBtnEnabled: true,
      dateErrorMsg: null,
      selectedEndDate: null,
      showLoader: false
    }
  },
  componentWillMount() {


  },
  componentWillReceiveProps(nextProps) {
    let reportsData = nextProps.Reports;
    reportsData.MySelfCare && this.setState({ MySelfCare: reportsData.MySelfCare.data });
    reportsData.MyThoughts && this.setState({ MyThoughts: reportsData.MyThoughts.data });
    reportsData.MyActivity && this.setState({ MyActivity: reportsData.MyActivity.data });
    reportsData.MyExperience && this.setState({ MyExperience: reportsData.MyExperience.data });
    this.setState({ showLoader: false });
    // debugger
  },
  componentDidMount() {
    let date = new Date();
    let summaryEndDate = new Date();
    summaryEndDate.setDate(summaryEndDate.getDate() - 7);
    let startDateNew = summaryEndDate.getFullYear() + '-' + ('0' + (summaryEndDate.getMonth() + 1)).slice(-2) + '-' + ('0' + summaryEndDate.getDate()).slice(-2);
    // let startDateNew = summaryEndDate.getFullYear() + "-" + (summaryEndDate.getMonth() + 1) + "-" + (summaryEndDate.getDate());
    // let endDateNew = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    let endDateNew = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    let ds = endDateNew.split('-');
    this.setState({ startDate: startDateNew, endDate: endDateNew, selectedEndDate: date }, () => {
      this.showChartData();
      this.setState({ showLoader: true });
    });
  },

  showChartData() {
    //MySelfCareData
    let fid = validate.getUrlParam("f_id");
    let uid = validate.getUrlParam("id");
    let data = uid + "/" + fid + "/" + this.state.startDate + "/" + this.state.endDate;
    // console.log(data);
    this.props.Dispatch(ReportActions.getMyExperienceData(data));
    // debugger
    //this.props.Dispatch(ReportActions.getmyActivityData(data));
    //this.props.Dispatch(ReportActions.getSelfCareData(data));
    //this.props.Dispatch(ReportActions.getMythoughtsData(data));
  },
  handleSelect(index, last) {
    // console.log('Selected tab: ' + index + ', Last tab: ' + last);
    this.setState({ CurrentTab: index });
    let fid = validate.getUrlParam("f_id");
    let uid = validate.getUrlParam("id");
    let data = uid + "/" + fid + "/" + this.state.startDate + "/" + this.state.endDate;
    switch (index) {
      case 0:
        this.props.Dispatch(ReportActions.getMyExperienceData(data));
        break;
      case 1:
        this.setState({ MyActivity: null });
        this.props.Dispatch(ReportActions.getmyActivityData(data));
        break;
      case 2:
        this.props.Dispatch(ReportActions.getSelfCareData(data));
        break;
      case 3:
        this.props.Dispatch(ReportActions.getMythoughtsData(data));
        break;
      default:

    }
  },

  closebox() {
    this.setState({ modal_pwd: false, modal: false, modal_msg: "", isActivation: false, resetpwd: false, resetPasswordResponseError: null });

  },
  genderateSelfCareReport() {
    let careData = this.state.MySelfCare;

    let sleep = {
      datar: { sleep: careData && careData.dailyWSData.dailyRest.data },
      //     datar:{sleep : [200, -230, 190, 40, 130, 220]} ,
      config: {

        x: {
          type: 'category',
          categories: careData && careData.dailyWSData.dailyRest.categories
          //categories: ['cat1', 'cat2', 'cat3', 'cat4', 'cat5', 'cat6']
        },
        y: {
          label: { position: 'outer-center', text: "Sleep Hours" }
        }

      },
      pie: {
        "Medication was taken this week": careData ? [careData.weekMedication[0]] : [0]

        //data: [20],
        //data2: [20]
      },
      color: {
        pattern: ['#53A7E1', '#ffffff']
      }

    }

    return sleep;
  },

  formatDate(d) {
    return moment(d).utcOffset('+0100').format('MM/DD/YYYY')
    // return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear());
  },

  wakeNsleep() {
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let wakeSleepData = this.state.MySelfCare ? this.state.MySelfCare.dailyWSData.dailyWakeUpAndSleepTime : [];
    let rest = this.state.MySelfCare ? this.state.MySelfCare.dailyWSData.dailyRest.data : [];
    var temp = wakeSleepData && wakeSleepData.length ? wakeSleepData.map(function (list, key) {
      let day = new Date(list.date.replace('-', '/'))
      return (<tr key={key}><td>{days[day.getDay()]}</td>
        <td>{list.date ? this.formatDate(new Date(list.date)) : 'N/A'}</td><td>{list.sleepTime}</td><td>{list.wakeTime}</td><td>{rest[key]}</td></tr>);
    }, this) : (<tr><td colSpan="4">No Records Found</td></tr>);

    return temp;
  },
  dailyMeditation() {

    let dailyMeditationData = this.state.MySelfCare ? this.state.MySelfCare.dailyMedication : [];

    var temp = dailyMeditationData && dailyMeditationData.length ? dailyMeditationData.map(function (list, key) {

      return (<tr key={key}><td>{list.day}</td><td>{list.date ? this.formatDate(new Date(list.date)) : 'N/A'}</td><td className={list.action && list.action != '--' && list.action.length > 0 ? (list.action.includes("Yes") ? 'colorgreen' : 'colorred') : ''}>{list.action}</td></tr>);
    }, this) : (<tr><td colSpan="3">No Records Found</td></tr>);
    return temp;
  },
  genderateMyActivitireport() {

    let myActivity_data = this.state.MyActivity;
    var w1 = myActivity_data && myActivity_data.weeklyActivity.activity.catagories[0],
      w2 = myActivity_data && myActivity_data.weeklyActivity.activity.catagories[1],
      w3 = myActivity_data && myActivity_data.weeklyActivity.activity.catagories[2];

    let dailySocializ = {
      var_data: {
        "Days I socialized": myActivity_data && myActivity_data.socialEnjoyment.data
        //  categories:  [20, 30, 19, 40, 10, 20],
      },
      config: {

        x: {
          type: 'category',
          categories: myActivity_data ? myActivity_data.socialEnjoyment.categories : [],
          //    label:{position: 'outer-right',text:"Social Enjoyment"}
        },
        y: {
          label: { position: 'outer-center', text: "Social enjoyment" },
          max: 7
        }
      },
      grid: {
        x: {
          show: true
        },
        y: {
          show: true
        }
      }

    };
    let socialDesire = {
      var_data: {
        "Days that I didn't socialize": myActivity_data && myActivity_data.socialDesire.data
        //  categories:  [20, 30, 19, 40, 10, 20],
      },
      config: {

        x: {
          type: 'category',
          categories: myActivity_data ? myActivity_data.socialDesire.categories : [],
          //    label:{position: 'outer-right',text:"Social desire"}
        },
        y: {
          label: { position: 'outer-center', text: "Social desire" },
          max: 7
        }
      },
      grid: {
        x: {
          show: true
        },
        y: {
          show: true
        }
      }

    };
    let SocialConflict = {
      var_data: {
        'Distress': myActivity_data && myActivity_data.responseToSocialConflict.data.hasOwnProperty('distress') ? myActivity_data.responseToSocialConflict.data.distress : [0, 0, 0, 0, 0, 0, 0],
        'Angry/Frustrated': myActivity_data && myActivity_data.responseToSocialConflict.data.hasOwnProperty('frustrated') ? myActivity_data.responseToSocialConflict.data.frustrated : [0, 0, 0, 0, 0, 0, 0]
      }, config: {
        x: {
          type: 'category',
          categories: myActivity_data ? myActivity_data.responseToSocialConflict.catagories : []
        },
        y: {
          //   label:{position: 'outer-center',text:"Social and Support"},
          max: 7
        }, legend: {
          show: false
        }
      },

      color: {
        pattern: ['#FFD966', '#C00000']
      },

    };
    let weeklySocializ = {

      var_data: {
        'Felt Social': myActivity_data && myActivity_data.weeklyActivity.activity.data.hasOwnProperty('feltSocial') ? myActivity_data.weeklyActivity.activity.data.feltSocial : [0, 0, 0, 0, 0, 0, 0],
        'Felt Supported': myActivity_data && myActivity_data.weeklyActivity.activity.data.hasOwnProperty('feltSupported') ? myActivity_data.weeklyActivity.activity.data.feltSupported : [0, 0, 0, 0, 0, 0, 0]
      }, config: {
        x: {
          max: 2,
          type: 'category',
          categories: myActivity_data && myActivity_data.weeklyActivity.activity.catagories
        },
        y: {
          //   label:{position: 'outer-center',text:"Social and Support"},
          max: 7
        }, legend: {
          show: false
        }
      },

      color: {
        pattern: ['#5B9BD5', '#ED7D31']
      },
      // old graph start
      //   var_data:{ week1 :  myActivity_data && myActivity_data.weeklyActivity.activity.data.week1,
      //     week2 :  myActivity_data && myActivity_data.weeklyActivity.activity.data.week2,
      //     week3 :  myActivity_data && myActivity_data.weeklyActivity.activity.data.week3
      //        } ,  config : {
      //                     x: {
      //                            type: 'category',
      //                            categories:['Felt Social','Felt Supported']
      //                        },
      //                     y:{
      //                         label:{position: 'outer-center',text:"Social Desire and Support"},
      //                         max: 7
      //                     },   legend: {
      //                         show: false
      //                     }
      //       },

      //       color: {
      //               pattern: ['#53A7E1','#F5A523','#50E2C1']
      //           },
      // old graph end

    };

    return {
      dailySocializ: dailySocializ,
      weeklySocializ: weeklySocializ,
      socialDesire: socialDesire,
      SocialConflict: SocialConflict
    };
  },

  generateMyExpReport() {
    let myexp_data = this.state.MyExperience;
    let exp = {
      line: {
        //data: [200, -230, 190, 40, 130, 220], //MyExperienc2-3 Mediume
        // "0-2 Low": "",
        // "2-3 Medium": "",
        // "4-5 High": "",
        "Mood": myexp_data ? myexp_data.dailyExperiences.data : [0],
      },
      mymood: {
        // "0-2 Low": "",
        // "2-3 Medium": "",
        // "4-5 High": "",
        Happy: myexp_data && myexp_data.weeklyMood.data.Happy ? myexp_data.weeklyMood.data.Happy : myexp_data && myexp_data.weeklyMood.data.Happy ? myexp_data && myexp_data.weeklyMood.data.Happy.length : [0, 0], //[1,1,2,2],
        Lively: myexp_data && myexp_data.weeklyMood.data.Lively ? myexp_data.weeklyMood.data.Lively : myexp_data && myexp_data.weeklyMood.data.Lively ? myexp_data && myexp_data.weeklyMood.data.Lively.length : [0, 0], // [7,4,5 ,3],
        Sad: myexp_data && myexp_data.weeklyMood.data.Sad ? myexp_data.weeklyMood.data.Sad : myexp_data && myexp_data.weeklyMood.data.Sad ? myexp_data && myexp_data.weeklyMood.data.Sad.length : [0, 0], //[3,4,1,6],
        Anxious: myexp_data && myexp_data.weeklyMood.data.Anxious ? myexp_data.weeklyMood.data.Anxious : myexp_data && myexp_data.weeklyMood.data.Anxious ? myexp_data && myexp_data.weeklyMood.data.Anxious.length : [0, 0], //[2,3,4,1],
        Confused: myexp_data && myexp_data.weeklyMood.data.Confused ? myexp_data.weeklyMood.data.Confused : myexp_data && myexp_data.weeklyMood.data.Confused ? myexp_data && myexp_data.weeklyMood.data.Confused.length : [0, 0], // [7,4,5,3],
        Overwhelmed: myexp_data && myexp_data.weeklyMood.data.Overwhelmed ? myexp_data.weeklyMood.data.Overwhelmed : myexp_data && myexp_data.weeklyMood.data.Overwhelmed ? myexp_data && myexp_data.weeklyMood.data.Overwhelmed.length : [0, 0], //[6,4,3,3]
      },
      psychosis: {
        // "0-2 Low": "",
        // "2-3 Medium": "",
        // "4-5 High": "",
        "On Guard": myexp_data && myexp_data.weeklyPsychosis.data.Guard ? myexp_data.weeklyPsychosis.data.Guard : myexp_data && myexp_data.weeklyPsychosis.data.Guard ? myexp_data && myexp_data.weeklyPsychosis.data.Guard.length : [0, 0], //[1,1,2,2],
        "Hearing Sounds": myexp_data && myexp_data.weeklyPsychosis.data.Hearing ? myexp_data.weeklyPsychosis.data.Hearing : myexp_data && myexp_data.weeklyPsychosis.data.Hearing ? myexp_data && myexp_data.weeklyPsychosis.data.Hearing.length : [0, 0], //[7,4,5 ,3],
        "Seeing Things": myexp_data && myexp_data.weeklyPsychosis.data.Seeing ? myexp_data.weeklyPsychosis.data.Seeing : myexp_data && myexp_data.weeklyPsychosis.data.Seeing ? myexp_data && myexp_data.weeklyPsychosis.data.Seeing.length : [0, 0], //[3,4,1,6]
      },
      motivation: {
        // "0-2 Low": "",
        // "2-3 Medium": "",
        // "4-5 High": "",
        "Hopeful": myexp_data && myexp_data.weeklyMotivation.data.Hopeful ? myexp_data.weeklyMotivation.data.Hopeful : myexp_data && myexp_data.weeklyMotivation.data.Hopeful ? myexp_data && myexp_data.weeklyMotivation.data.Hopeful.length : [0, 0], //[1,1,2,2],
        "Didn't Care": myexp_data && myexp_data.weeklyMotivation.data.DidNotCare ? myexp_data.weeklyMotivation.data.DidNotCare : myexp_data && myexp_data.weeklyMotivation.data.DidNotCare ? myexp_data && myexp_data.weeklyMotivation.data.DidNotCare.length : [0, 0], //[7,4,5 ,3],
        "Unmotivated": myexp_data && myexp_data.weeklyMotivation.data.Unmotivated ? myexp_data.weeklyMotivation.data.Unmotivated : myexp_data && myexp_data.weeklyMotivation.data.Unmotivated ? myexp_data && myexp_data.weeklyMotivation.data.Unmotivated.length : [0, 0], //[3,4,1,6]
      },
      configLine: {
        x: {
          type: 'category',
          //categories: ['cat1', 'cat2', 'cat3', 'cat4', 'cat5', 'cat6']
          categories: myexp_data ? myexp_data.dailyExperiences.categories : [],
        },
        y: {
          label: { position: 'outer-right', text: "My Daily Mood" },
          // max: 4.8,
          max: 7,

        }
      },
      configMyMood: {
        x: {
          type: 'category',
          categories: myexp_data ? myexp_data.weeklyMood.catagories : []//["2015-11-20", "2015-11-21", "2015-11-22", "2015-11-23", "2015-11-24", "2015-11-25"]
        },
        y: {
          label: { position: 'outer-right', text: "My Weekly Mood" },
          // max: 4.8
          max: 5,
          tick: { values: [0, 1, 2, 3, 4, 5] }
        }
      },
      configMyPsychosis: {
        x: {
          type: 'category',
          categories: myexp_data ? myexp_data.weeklyPsychosis.catagories : [0], //["2015-11-20", "2015-11-21", "2015-11-22", "2015-11-23", "2015-11-24", "2015-11-25"]
        },
        y: {
          label: { position: 'outer-right', text: "My Weekly Psychosis" },
          // max: 4.8
          max: 5,
          tick: { values: [0, 1, 2, 3, 4, 5] }
        }
      },
      configMyMotivation: {
        x: {
          type: 'category',
          categories: myexp_data ? myexp_data.weeklyMotivation.catagories : [0],//["2015-11-20", "2015-11-21", "2015-11-22", "2015-11-23", "2015-11-24", "2015-11-25"]
        },
        y: {
          label: { position: 'outer-right', text: "My Weekly Motivation" },
          // max: 4.8
          max: 5,
          tick: { values: [0, 1, 2, 3, 4, 5] }
        }
      },
      configMyMoodColor: {
        //previous colors
        // pattern: ['#FF99FF', '#FF3399', '#5795CC', '#95BEE4', '#BAD5ED', '#D3E4F4']
        // pattern: ['pink', 'pink', 'blue', 'blue', 'blue', 'blue']
        pattern: ['#E75480', 'pink', '#0000FF', '#4682B4', '#87CEEB', '#ADD8E6'] //{#E75480 : Dark pink, #0000FF : blue, #4682B4 : steelblue, #87CEEB : skyblue, #ADD8E6: lightblue  }
      },
      configMyPsychosisColor: {
        pattern: ['#71A071', '#66CC66', '#20971E']
      },
      configMyMotivationColor: {
        //pattern: ['#76E7D6', '#4DA296', '#15BEA4']
        // pattern: ['#FF6699', '#33CCCC', '#81FFFF']
        pattern: ['pink', '#0000FF', '#4682B4']

      },
      width: {
        width: 12
      }
    };
    return exp;
  },
  handleFromDateChange() {
    // this.setState({MyActivity:null})
    // debugger;
    let date = this.refs["from-date"].input.value.replace(/[^\w\s]/gi, '-');
    let ds = date.split('-');
    this.setState({ startDate: ds[2] + "-" + ds[0] + "-" + ds[1], isSubmitBtnEnabled: false });
    // debugger
    // this.setState({ selectedFromDayDisplay: ds[0] + "-" + ds[1] + "-" + ds[2] }); //yy-mm-dd
    this.setState({ startDateDisplay: ds[0] + "/" + ds[1] + "/" + ds[2] }); //MM-DD-YYYY

    let inputStartDate = this.refs["from-date"].input.value;
    let inputStartDateNew = new Date(inputStartDate);
    let newdate = new Date(inputStartDateNew);
    newdate.setDate(newdate.getDate() + 14);
    let dd = ('0' + newdate.getDate()).slice(-2);
    let mm = ('0' + (newdate.getMonth() + 1)).slice(-2);
    let y = newdate.getFullYear();

    let startFormattedDate = mm + '/' + dd + '/' + y;
    let startFormattedDateDisplay = y + '-' + mm + '-' + dd;
    this.refs["to-date"].input.value = startFormattedDate;
    this.setState({ endDateDisplay: startFormattedDate, endDate: startFormattedDateDisplay, selectedEndDate: startFormattedDate }, () => {
      if (new Date(this.state.endDate) > new Date()) {
        let newInputStartDate = this.refs["from-date"].input.value;
        let inputNewStartDate = new Date(newInputStartDate);
        let newdates = new Date(inputNewStartDate);
        let dd = ('0' + newdates.getDate()).slice(-2);
        let mm = ('0' + (newdates.getMonth() + 1)).slice(-2);
        let y = newdates.getFullYear();
        let newStartFormattedDate = mm + '/' + dd + '/' + y;
        let newStartFormattedDateDisplays = y + '-' + mm + '-' + dd;
        this.refs["to-date"].input.value = newStartFormattedDate;
        this.setState({ endDateDisplay: newStartFormattedDate, endDate: newStartFormattedDateDisplays });
      }
    });
  },
  handleToDateChange() {
    let date = this.refs["to-date"].input.value.replace(/[^\w\s]/gi, '-');
    let ds = date.split('-');
    this.setState({ endDate: ds[2] + "-" + ds[0] + "-" + ds[1], isSubmitBtnEnabled: false });
    this.setState({ endDateDisplay: ds[0] + "/" + ds[1] + "/" + ds[2] }); //MM-DD-YYYY

    let inputEndDate = this.refs["to-date"].input.value;
    let inputEndDateNew = new Date(inputEndDate);
    let newdate = new Date(inputEndDateNew);
    let dd = ('0' + newdate.getDate()).slice(-2);
    let mm = ('0' + (newdate.getMonth() + 1)).slice(-2);
    let y = newdate.getFullYear();

    let endFormattedDate = mm + '/' + dd + '/' + y;
    let endFormattedDateDisplay = y + '-' + mm + '-' + dd;
    this.refs["to-date"].input.value = endFormattedDate;
    this.setState({ endDateDisplay: endFormattedDate, endDate: endFormattedDateDisplay }, () => {
      if (new Date(this.state.startDate) === new Date(this.state.endDate)) {
        let newInputFromDate = this.refs["from-date"].input.value;
        let inputNewFromDate = new Date(newInputFromDate);
        let newdates = new Date(inputNewFromDate);
        let dd = ('0' + newdates.getDate()).slice(-2);
        let mm = ('0' + (newdates.getMonth() + 1)).slice(-2);
        let y = newdates.getFullYear();
        let endNewFormattedDates = mm + '/' + dd + '/' + y;
        let endNewFormattedDateDisplays = y + '-' + mm + '-' + dd;
        this.refs["to-date"].input.value = endNewFormattedDates;
        this.setState({ endDateDisplay: endNewFormattedDates, endDate: endNewFormattedDateDisplays });
      } else if (new Date(this.state.endDate) > new Date() || new Date(this.state.endDate) < new Date()) {
        let newInputFromDate = this.refs["to-date"].input.value;
        let inputNewFromDate = new Date(newInputFromDate);
        let newdates = new Date(inputNewFromDate);
        let dd = ('0' + newdates.getDate()).slice(-2);
        let mm = ('0' + (newdates.getMonth() + 1)).slice(-2);
        let y = newdates.getFullYear();
        let endNewFormattedDates = mm + '/' + dd + '/' + y;
        let endNewFormattedDateDisplays = y + '-' + mm + '-' + dd;
        this.refs["to-date"].input.value = endNewFormattedDates;
        this.setState({ endDateDisplay: endNewFormattedDates, endDate: endNewFormattedDateDisplays });
      }
    });
  },
  handleSubmit() {
    if (this.state.startDate > this.state.endDate) {
      this.setState({ dateErrorMsg: 'Start date should be less than end date.', isSubmitBtnEnabled: true })
    } else {
      this.setState({ dateErrorMsg: '', isSubmitBtnEnabled: false })
      if (this.state.CurrentTab === 0) {
        this.handleSelect(this.state.CurrentTab);
      } else if (this.state.CurrentTab === 1) {
        this.setState({ MyActivity: null })
        this.handleSelect(this.state.CurrentTab);

      } else if (this.state.CurrentTab === 2) {
        this.handleSelect(this.state.CurrentTab)

      } else if (this.state.CurrentTab === 3) {
        this.handleSelect(this.state.CurrentTab)
      }
    }
  },
  formatSurveyDate(e) {
    var datePart = e.match(/\d+/g),
      year = datePart[0], // get only two digits
      month = datePart[1], day = datePart[2];
    return month + '/' + day + '/' + year;
  },
  render() {

    let chartData = this.generateMyExpReport();
    // debugger
    let chartSelfCare = this.genderateSelfCareReport();
    let myActivitiReport = this.genderateMyActivitireport();
    // debugger;
    let tabelReport = this.wakeNsleep();
    let dailyMeditationReport = this.dailyMeditation();

    let MyDate = new Date();
    // let date = new Date();
    let summaryEndDate = new Date();
    summaryEndDate.setDate(summaryEndDate.getDate() - 7);
    let startDateNew = ('0' + (summaryEndDate.getMonth() + 1)).slice(-2) + '/' + ('0' + summaryEndDate.getDate()).slice(-2) + '/' + summaryEndDate.getFullYear();
    // (summaryEndDate.getMonth() + 1) + "/" + summaryEndDate.getDate() + "/" + summaryEndDate.getFullYear();
    // let endDateNew = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
    let endDateNew = ('0' + (MyDate.getMonth() + 1)).slice(-2) + '/' + ('0' + MyDate.getDate()).slice(-2) + '/' + MyDate.getFullYear();
    let fromDate = this.state.startDate ? this.state.startDateDisplay : startDateNew;
    let toDate = this.state.endDate ? this.state.endDateDisplay : endDateNew;

    const startDayPickerProps = {
      disabledDays: {
        // before: new Date(startDateNew),
        after: new Date(),
      }
      // selectedDays: new Date(2017, 1, 12),

    };
    // console.log(new Date(this.state.selectedEndDate));
    const endDayPickerProps = {
      disabledDays: {
        before: new Date(this.state.startDate),
        after: new Date(this.state.selectedEndDate) < new Date() ? new Date(this.state.selectedEndDate) : new Date(),
      }
    };

    var graph_confi = {
      grid: {
        x: {
          show: false
        },
        y: {
          show: true
        }
      },
      bar: {
        width: 28,// this makes bar width 100px,        
        space: 0.25
      }
      ,
      legend: {
        position: 'bottom-righ'
      },
      color: {
        pattern: ['#53A7E1', '#F5A523', '#50E2C1']
      },
      // bar: {
      //   space: 0.25
      // }
    }
    return (

      <div className="dashboard-inner-content">
        <Header screenIdentifier={screenIdentifier} breadcrumb={true} />
        <div className="breadcrumb-custom">
          <h2> <Link to="/patients">PATIENTS</Link> > <a onClick={this.props.router.goBack} >{this.props.FacilitiesDetails.FaciliteAdminUser.data.firstName}</a> > Summary</h2>
        </div>
        <div className="admin-details">
          <div className="row">

          </div>

          <div className="white-box">

            <div className="generate-date d-flex">
              <div className='date-block'>
                <div className="col-xs-6 padding-left-5 padding-right-none from-date" onFocus={this.removeError}>
                  <span className="">Start date : </span>
                  <DayPickerInput readOnly ref="from-date" placeholder="MM/DD/YYYY" value={fromDate} onDayChange={this.handleFromDateChange} dayPickerProps={startDayPickerProps} />
                </div>

                <div className="col-xs-6 padding-left-5 padding-right-none to-date" onFocus={this.removeError}>
                  <span className="from ">End date :  </span>
                  <DayPickerInput readOnly ref="to-date" value={toDate} placeholder="MM/DD/YYYY" onDayChange={this.handleToDateChange} dayPickerProps={endDayPickerProps} />
                </div>
                <button className='submit-btn' disabled={this.state.isSubmitBtnEnabled} onClick={() => { this.handleSubmit() }}>Submit</button>
              </div>
              <span className='error-msg'>{this.state.dateErrorMsg}</span>
              <div className="clearfix"></div>
            </div>
            <Tabs onSelect={this.handleSelect} selectedIndex={this.state.CurrentTab} >

              <TabList className="nav nav-tabs">
                <Tab className="button">MY EXPERIENCES</Tab>
                <Tab className="button">MY ACTIVITIES</Tab>
                <Tab className="button">MY SELF-CARE</Tab>
                <Tab className="button">MY THOUGHTS</Tab>
              </TabList>
              <TabPanel>
                <div className="mu_experiences">
                  <div className="row">
                    <div className="col-sm-6 col-md-6  reports_container" key={Math.random()}>
                      <h3> MY Daily Mood</h3> {console.log("graph_confi.bar", chartData)}
                      {chartData.configLine.x.categories && chartData.configLine.x.categories.length > 0 && <C3Chart data={{ json: chartData.line, type: 'bar' }} axis={chartData.configLine} grid={graph_confi.grid} bar={graph_confi.bar} color={graph_confi.color} space={2} />}
                      {chartData.configLine.x.categories && chartData.configLine.x.categories.length === 0 && <div className='no-data'>No Data found.</div>}
                    </div>
                    <div className="col-md-6 col-sm-6  reports_container" key={Math.random()}>
                      <h3> MY WEEKLY MOOD</h3>
                      {/* {chartData.configMyMood.x.categories && chartData.configMyMood.x.categories.length > 1 && <C3Chart data={{ json: chartData.mymood, type: 'bar' }} axis={chartData.configMyMood} grid={graph_confi.grid} bar={graph_confi.bar} color={graph_confi.color} space={2} />}
                      {chartData.configMyMood.x.categories && chartData.configMyMood.x.categories.length === 1 && <div className='no-data'>No Data found.</div>} */}
                      {chartData.configMyMood.x.categories && chartData.configMyMood.x.categories.length > 0 && <C3Chart data={{ json: chartData.mymood, type: 'bar' }} axis={chartData.configMyMood} bar={graph_confi.bar} grid={graph_confi.grid} bar={chartData.width} color={chartData.configMyMoodColor} />}
                      {chartData.configMyMood.x.categories && chartData.configMyMood.x.categories.length === 0 && <div className='no-data'>No Data found.</div>}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-sm-6 reports_container" key={Math.random()}>
                      <h3>MY WEEKLY PSYCHOSIS</h3>
                      {chartData.configMyPsychosis.x.categories && chartData.configMyPsychosis.x.categories.length > 0 && <C3Chart data={{ json: chartData.psychosis, type: 'bar' }} axis={chartData.configMyPsychosis} bar={graph_confi.bar} grid={graph_confi.grid} bar={chartData.width} color={chartData.configMyPsychosisColor} />}
                      {chartData.configMyPsychosis.x.categories && chartData.configMyPsychosis.x.categories.length === 0 && <div className='no-data'>No Data found.</div>}
                    </div>

                    <div className="col-md-6 col-sm-6 reports_container" key={Math.random()}>
                      <h3>MY WEEKLY MOTIVATION</h3>
                      {chartData.configMyMotivation.x.categories && chartData.configMyMotivation.x.categories.length > 0 && <C3Chart data={{ json: chartData.motivation, type: 'bar' }} axis={chartData.configMyMotivation} bar={graph_confi.bar} grid={graph_confi.grid} bar={chartData.width} color={chartData.configMyMotivationColor} />}
                      {chartData.configMyMotivation.x.categories && chartData.configMyMotivation.x.categories.length === 0 && <div className='no-data'>No Data found.</div>}

                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="my_activities">
                  <div className="reports_container">
                    <h2>Social Enjoyment</h2>
                    <p>Enjoyment on days I socialized face-to-face</p>
                    <div className="graph">
                      {myActivitiReport.dailySocializ.config.x.categories && myActivitiReport.dailySocializ.config.x.categories.length > 1 && <C3Chart data={{ json: myActivitiReport.dailySocializ.var_data, type: 'bar' }} axis={myActivitiReport.dailySocializ.config} grid={graph_confi.grid} bar={graph_confi.bar} legend={graph_confi.legend} />}
                    </div>
                  </div>
                  <div className="reports_container">
                    <h2>Social Desire</h2>
                    <p>Desire to socialize (on days that I didn't)</p>
                    <div className="graph">
                      {myActivitiReport.socialDesire.config.x.categories && myActivitiReport.socialDesire.config.x.categories.length > 1 && <C3Chart data={{ json: myActivitiReport.socialDesire.var_data, type: 'bar' }} axis={myActivitiReport.socialDesire.config} grid={graph_confi.grid} bar={graph_confi.bar} legend={graph_confi.legend} />}
                    </div>
                  </div>
                  <div className="reports_container">
                    <h2>Social Conflict</h2>
                    <p>Response to social conflict</p>
                    <div className="graph">
                      {myActivitiReport.SocialConflict.config.x.categories && myActivitiReport.SocialConflict.config.x.categories.length > 1 && <C3Chart data={{ json: myActivitiReport.SocialConflict.var_data, type: 'bar' }} axis={myActivitiReport.SocialConflict.config} grid={graph_confi.grid} bar={graph_confi.bar} legend={graph_confi.legend} color={myActivitiReport.SocialConflict.color} />}
                    </div>
                  </div>

                  {/* <div className="reports_container">
                    <h2>WEEKLY SOCIAL DESIRE & SUPPORT</h2>

                    <div className="graph">
                      <C3Chart data={{ json: myActivitiReport.weeklySocializ.var_data, type: 'bar' }} axis={myActivitiReport.weeklySocializ.config} bar={graph_confi.bar} grid={graph_confi.grid} bar={graph_confi.bar} color={myActivitiReport.weeklySocializ.color} legend={graph_confi.legend} />
                      <p className="text-center weeklysocialSupport">
                        <span className="l l1">{this.state.MyActivity && this.state.MyActivity.weeklyActivity.activity.catagories[0]}</span>
                                         <span className="l l2">{this.state.MyActivity && this.state.MyActivity.weeklyActivity.activity.catagories[1]}</span>
                                         <span className="l l3">{this.state.MyActivity && this.state.MyActivity.weeklyActivity.activity.catagories[2]}</span>
                      </p>
                    </div>
                  </div> */}
                </div>
              </TabPanel>
              <TabPanel>
                <div className="mu_selfcare">
                  <div className="row">
                    <div className="col-md-12 col-sm-12 reports_container">
                      <p>TIME AWAKE AND TIME ASLEEP (For prior day)</p>
                      <tabel className="table col-sm-6 col-md-6  "><thead><tr><th></th><th></th><th>Sleep Time </th> <th>Wake Up Time</th><th>Total Sleep Time</th></tr></thead>
                        <tbody>{tabelReport}</tbody></tabel>
                    </div>
                    {/*
                                    <div className="col-md-6 col-sm-6 reports_container">
                                       <p>DAILY REST WITH HOW MANY HOURS OF SLEEP</p>
                                         <div className="graph">
                                              <div className="">    <C3Chart data={{ json: chartSelfCare.datar, type: 'bar' }} axis = {chartSelfCare.config} bar={graph_confi.bar}  grid =  {graph_confi.grid} bar={graph_confi.bar} color={graph_confi.color} /> </div>
                                         </div>
                                     </div>
                                     */}
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-sm-12 reports_container">
                      <p>DAILY MEDICATION</p>
                      <tabel className="table dail_med">
                        <thead></thead>
                        <tbody>{dailyMeditationReport}</tbody>
                      </tabel>
                    </div>
                    {/*
                                      <div className="col-md-6 col-sm-6 reports_container">
                                           <p>WEEKLY MEDICATION</p>
                                           <div className="graph">
                                               <C3Chart data={{ json: chartSelfCare.pie, type:'pie'  }} color={chartSelfCare.color} />
                                           </div>
                                      </div>
                                      */}
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="mu_experiences">
                  <div className="reports_container">
                    <h3>Daily Conflict Notes</h3>
                    {/* <p>{this.state.MyThoughts && this.state.MyThoughts.dailyNote}</p> */}
                    <div className="reports_container_details">
                      {this.state.MyThoughts && this.state.MyThoughts.dailyNote &&
                        _.map(this.state.MyThoughts.dailyNote, (v, k) => {
                          return (<p key={k}>
                            <span>{this.formatSurveyDate(k)}</span> &nbsp;&nbsp;&nbsp; <span>{v === 'There are no daily survey notes available' ? '--' : v}</span>
                          </p>);
                        })
                      }
                    </div>
                  </div>
                  <div className="reports_container">
                    <h3>WEEKLY SURVEY NOTES</h3>
                    {/* <p>{this.state.MyThoughts && this.state.MyThoughts.weeklyNote}</p> */}
                    <div className="reports_container_details">
                      {this.state.MyThoughts && this.state.MyThoughts.weeklyNote &&
                        _.map(this.state.MyThoughts.weeklyNote, (v, k) => {
                          return (<p key={k}>
                            <span>{this.formatSurveyDate(k)}</span> &nbsp;&nbsp;&nbsp; <span>{v === 'There are no weekly survey notes available' ? '--' : v}</span>
                          </p>);
                        })
                      }
                    </div>
                  </div>
                </div>
              </TabPanel >
            </Tabs >
          </div >
        </div >
        <div> {this.state.modal_pwd ? <ModalDialogCommon message={this.state.modal_msg} action={this.closebox} /> : ""}</div>
        {this.state.showLoader && <div><Loader /></div>}

      </div >

    );
  }
});


let mapStateToProps = (state) => {
  return {
    PatientsDetails: state.Patients,
    UserDetails: state.User,
    Reports: state.Reports,
    FacilitiesDetails: state.Facilites

  };
};

let mapDispatchToProps = (dispatch) => ({
  ReportActions: bindActionCreators(ReportActions, dispatch),
  Dispatch: dispatch
});
export default connect(mapStateToProps,
  mapDispatchToProps)(withRouter(PatientsSummery));


//  <div className="button pull-right all-days"> <button className="icon-box">ALL DAYS</button>  </div>



/** WEBPACK FOOTER **
 ** ./src/components/admin/patients/patients-summery.js
 **/